import React, { useState, useEffect } from "react";
import { BtnChiTiet } from "./ChiTiet/BtnChiTiet";
import { BtnChiTietDanhGia } from "./ChucNang/ChiTietDanhGia/BtnChiTietDanhGia";

export const ContentTable = ({ dataTicket }) => {
  // Tạo một state để lưu trạng thái của các checkbox đã chọn
  const [checkedItems, setCheckedItems] = useState({});
  // useEffect(() => {
  //   // checkedItems=listDaTicket;
  //   const initialCheckedItems = listTicketFull.reduce((acc, item) => {
  //     acc[item.MaTaiSan] = item.TrangThai === 1;
  //     return acc;
  //   }, {});
  //   setCheckedItems(initialCheckedItems);
  // }, [listTicketFull]);
  const addDanhGia = (item) => {
    window.location.href = "/Ticket/DanhGia.aspx?idTicket=" + item.Id;
  };
  return dataTicket.TicketResults.map((item, index) => (
    <div className="custom-table-row" key={item.keyCode}>
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center">{index + 1}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-30 flex-basis-30-sm">
        <BtnChiTiet item={item} />
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
        <span className="mobile-column-name">Chức năng</span>
        <div className="center-wrapper">
          {item.ChucNang === "CamDo" && <p className="text-center">Cầm đồ</p>}
          {item.ChucNang === "TinChap" && <p className="text-center">Tín chấp</p>}
          {item.ChucNang === "TraGop" && <p className="text-center">Trả góp</p>}
          {item.ChucNang !== "CamDo" && item.ChucNang !== "TinChap" && item.ChucNang !== "TraGop" && <p className="text-center">Khác</p>}
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
        <span className="mobile-column-name">Ngày tạo</span>
        <div className="center-wrapper">
          <p className="text-center">{item.NgayTao}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
        <span className="mobile-column-name">Người tiếp nhận</span>
        <div className="center-wrapper">
          <p className="text-center">{item.NguoiDangXuLy}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
        <span className="mobile-column-name">Deadline</span>
        <div className="center-wrapper">
          <p className="text-center">{item.Deadline}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-15 flex-basis-15-sm ">
        <span className="mobile-column-name">Trạng Thái</span>
        <div className="center-wrapper">
          <p className="text-center">{item.TenTrangThai}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm ">
        <span className="mobile-column-name">Thao Tác</span>
        <div className="center-wrapper text-center">
          {item.TenTrangThai === "Hoàn thành" &&
            item.DanhGia.length === 0 && (
              <a
                href={() => false}
                class="iconTable-Main"
                onClick={(e) => addDanhGia(item)}
              >
                <img src="/app-assets/images/tabler_pencil-star.png" style={{ width:"20px" }} title="Đánh giá" alt="" />
              </a>
            )}
           &nbsp;
          {item.DanhGia.length > 0 && (
            <BtnChiTietDanhGia item={item} />
          )}
        </div>
      </div>
    </div>
  ));
};
